<template>
  <section>
    <div class="desktop_margin">
      <v-overlay :value="set_overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <AdminHeader :headerName="$t('newUi.widget.header')" view_form="" />
      <h5 class="col text-center">{{ $t("newUi.widget.header") }}</h5>
      <div class="col text-start">
        {{ $t("newUi.widget.subtitle") }}
      </div>
      <ul class="pt-5">
        <strong class="step-title-class">{{ $t("newUi.widget.step1") }}</strong>
        <li>
          {{ $t("newUi.widget.instruction") }}
        </li>
      </ul>
      <div class="col veritical-align-middle">
        <div class="col veritical-align-middle">
          <label v-if="phone_data.phone == ''">{{
            $t("newUi.widget.num")
          }}</label>
          <label v-if="phone_data.phone.length != 0">{{
            $t("newUi.widget.editNum")
          }}</label>
          <vue-tel-input
            :autoFormat="false"
            :showDialCode="true"
            :value="
              phone_data.nationalPhone
                ? phone_data.nationalPhone
                : phone_data.phone
            "
            :autoDefaultCountry="true"
            :dropdownOptions="{
              showFlags: true,
              showDialCodeInList: true,
              showDialCodeInSelection: true,
            }"
            :inputOptions="{
              placeholder: $t('newUi.createOrderForm.phoneNumber'),
            }"
            @input="onInput"
            @country-changed="countryChanged"
            :validCharactersOnly="true"
            mode="international"
            id="create_for_widget_mobile1"
            @validate="onValidate"
            :enabledCountryCode="true"
            inputId="create_for_mobile"
          ></vue-tel-input>
          <div class="text-center">
            <v-btn
              class="mt-10 text-center text-none white--text"
              color="#8ab26d"
              @click="Create_link()"
              >{{ $t("newUi.widget.createButton") }}</v-btn
            >
          </div>
        </div>
      </div>
      <div v-if="phone_data.phone.length != 0">
        <div class="" v-if="phone_show">
          <ul>
            <strong class="step-title-class">{{
              $t("newUi.widget.step2")
            }}</strong>
            <li>
              {{ $t("newUi.widget.ins") }}
            </li>
          </ul>
          <div class="mt-4 col text-center">
            <h5>{{ $t("newUi.widget.title") }}</h5>
            <div id="copyscript" class="backgroundcolor">
              <div class="text-start">{{ startscripttag }}</div>
              <div class="inner_scripts">
                var s= document.createElement('script');
              </div>
              <div class="inner_scripts">
                var phone_number="{{ phone_number.return_number }}";
              </div>
              <div class="inner_scripts">
                s.src = "https://bzwidget.s3.amazonaws.com/widget.js";
              </div>
              <div class="inner_scripts">document.body.appendChild(s);</div>
              <div class="text-start">{{ endscripttag }}</div>
            </div>
            <div class="col text-center">
              <img
                class="cursor-pointer plus_icon"
                src="../assets/ui/copy_whatsapp_script_icon.svg"
                @click="doCopy"
                alt=""
              />
              <!-- <i class="bi bi-files" style="font-size: 30px;" @click="doCopy"></i> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import { loadNumber, saveNumber, setLocale } from "../services/firebase";
// import store from "../store/store";
import router from "../router/router";
import AdminHeader from "@/layout/adminHeader.vue";
import i18n from "../i18n";
export default {
  data() {
    return {
      name: "",
      showMessage: false,
      phone: "",
      phone_number: {
        return_number: "",
        national_number: "",
      },
      phone_valid: "",
      bodytag: "<body>",
      startscripttag: "<script>",
      endscripttag: "</" + "script>",
      phone_data: this.$store.state.whatsAppData,
      show_script: false,
      script_data: "",
      set_overlay: false,
    };
  },
  components: {
    AdminHeader,
  },
  props: ["payload"],
  mounted() {
    var state = this.$store.state;
    setLocale();
    this.fetchData(state);
  },
  watch: {
    $route: "fetchData",
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),

    phone_show: function() {
      let data = "";
      if (this.phone_data.phone.length != 0) {
        if (
          this.$store.state.whatsAppData.phone ==
          this.phone_number.return_number
        ) {
          //    if(this.show_script == true)
          data = true;
        } else {
          data = false;
        }
      }
      return data;
    },
  },
  methods: {
    fetchData(state) {
      if (state.profile.isSigned) {
        this.set_overlay = true;
        loadNumber(state.profile.uid, function() {});
        this.$store.dispatch("setOverlay", false);
        this.set_overlay = false;
      } else {
        router.push("/");
      }
    },
    onValidate: function({ nationalNumber, number, valid }) {
      // this.show_script = false
      if (valid == true) {
        this.show_script = false;
        this.mobile_number = nationalNumber;
        this.phone_number.return_number = number;
        this.phone_number.national_number = nationalNumber;
      } else {
        this.phone_number.return_number = "";
        this.phone_number.national_number = "";
      }
      this.phone_valid = valid;
    },
    onInput(formattedNumber, { number, nationalNumber, valid }) {
      this.phone_valid = valid;
      this.mobile_number = formattedNumber;
      this.phone_number.return_number = number;
      this.phone_number.national_number = nationalNumber;
    },
    countryChanged(formattedNumber) {
      this.data = formattedNumber;
    },
    Create_link: function() {
      // debugger;
      if (this.phone_valid == true) {
        this.$store.dispatch("setWhatsAppData", this.phone_number);

        // this.$store.dispatch("setOverlay", true);
        saveNumber(
          this.$store.state.profile.uid,
          new Date().getTime(),
          this.phone_number,
          function(error, response) {
            if (error) {
              alert(i18n.t("alertText.uploadFail"));
            } else console.log(response);
          }
        );
        this.show_script = true;
        // this.phone_data1 = this.$store.state.whatsAppData
      } else {
        alert(i18n.t("alertText.validatePhoneAlert"));
      }
    },
    generate_script: function() {
      if (this.phone_valid == true && this.phone_show == true) {
        this.script_data =
          `<script>` +
          `\t` +
          `\n` +
          `var s= document.createElement('script');` +
          `\t` +
          `\n` +
          `var phone_number=` +
          this.phone_number.return_number +
          `;` +
          `\t` +
          `\n` +
          `s.src = 'https://bzwidget.s3.amazonaws.com/widget.js';` +
          `\t` +
          `\n` +
          `document.body.appendChild(s);` +
          `\t` +
          `\n` +
          `</` +
          `script>`;
      }
    },
    doCopy: function() {
      this.generate_script();
      if (this.script_data != "") {
        var valtocopy = this.script_data;
        if (!valtocopy) return;
        var input = document.getElementById("clipcopyinput");
        document.body.appendChild(input);
        input.value = valtocopy;
        //input.focus();
        input.select();
        try {
          var successful = document.execCommand("copy");
          if (successful) {
            this.$store.state.snackbartext = i18n.t(
              "newUi.widget.scriptCopied"
            );
            this.$store.state.snackbar = true;
          }
        } catch (err) {
          console.log(err);
        }
        /* unselect the range */
        input.value = "";
        window.getSelection().removeAllRanges();
      }
    },
  },
};
</script>
<style lang="scss">
.backgroundcolor {
  background: #ebebeb;
  padding: 10px;
}
.inner_scripts {
  text-align: start;
  padding-left: 15px;
}
.vue-tel-input {
  border: none;
}
.vti__dropdown {
  background-color: #f8faf7;
}
.vti__input {
  margin-left: 5px;
  background-color: #f8faf7;
}
.step-title-class {
   color: #8AB26D;
   font-weight: 700;
   font-family: Roboto, sans-serif;
}
@media (min-width: 960px) {
  .desktop_margin {
    padding: 0rem 4rem;
  }
}
</style>
